function isValidEmail(email) {
  // remove white spaces
  const hasSpaces = /\s+/g.test(email);
  if (hasSpaces || email?.length <= 0) return false;

  return new RegExp("^[^@]+@[^@]+.[a-zA-Z]{2,}$").test(email);
}

export default isValidEmail;
